var React = require('react');

function Resize (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m4.10007 20.0001c-.15 0-.31-.06-.42-.18-.23-.23-.23-.61 0-.85l14.77003-14.7701h-3.5c-.33 0-.6-.27-.6-.6s.27-.6.6-.6h4.8965c.1711-.01531.3492.04138.4835.17006.1413.13545.1959.32293.17.5032v4.87674c0 .33-.27.6-.6.6s-.6-.27-.6-.6v-3.49997l-14.77003 14.77007c-.12.12-.28.18-.43.18zm6.33993-9.9001-5.92-5.92c-.23-.24-.61-.24-.84 0-.24.23-.24.61 0 .84l5.92 5.92zm4.5101 10.9001h4.95c.33 0 .6-.27.6-.6v-4.95c0-.33-.27-.6-.6-.6s-.6.27-.6.6v3.51l-5.9-5.9-.84.84 5.9 5.9h-3.51c-.33 0-.6.27-.6.6s.27.6.6.6z","fillRule":"evenodd"}));
}

Resize.defaultProps = {"fill":"currentColor","viewBox":"0 0 24 24"};

module.exports = Resize;

Resize.default = Resize;
